import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { HIGHLIGHT_101_COLOR } from "@hl/base-components/lib/theme/colors";
import { Text, Box, Group } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { HighlightTipIcon } from "../../assets/icons.generated";
import { getHighlightTipsActivity, setHighlightTipsActivity, } from "../../utils/highlightTips";
import { useGetOnboardingConfigQuery, } from "../quick-start/queries.graphql.generated";
export const OnboardingManager = () => {
    const { data } = useGetOnboardingConfigQuery();
    useEffect(() => {
        if (!data)
            return;
        data.getOnboardingConfig.tips.map((t) => {
            document.addEventListener(t.event, showHighlightTip);
        });
        return () => {
            data.getOnboardingConfig.tips.map((t) => {
                document.removeEventListener(t.event, showHighlightTip);
            });
        };
    }, [data]);
    const updateActivity = useCallback((tip) => {
        const newActivity = [...getHighlightTipsActivity(), tip];
        setHighlightTipsActivity(newActivity);
    }, []);
    const getActivity = (event) => {
        const activities = getHighlightTipsActivity();
        const eventActivity = activities.find((a) => a.event === event);
        return eventActivity || null;
    };
    const getActivityContent = (tips, event) => {
        return tips.find((c) => c.event === event);
    };
    const showHighlightTip = useCallback((e) => {
        const tips = (data === null || data === void 0 ? void 0 : data.getOnboardingConfig.tips) || [];
        const eventActivity = getActivity(e.type);
        if (eventActivity)
            return;
        const content = getActivityContent(tips, e.type);
        if (!content)
            return;
        updateActivity({ event: e.type, data: e.detail });
        showNotification({
            title: (_jsxs(Group, { spacing: 2, align: "center", children: [_jsx(HighlightTipIcon, {}), _jsx(Text, { size: "sm", weight: 500, children: "Highlight Tip" })] })),
            message: (_jsx(Box, { pt: 4, component: content.link ? "a" : "div", target: content.link ? "_blank" : "_self", href: content.link || "#", children: content.content })),
            autoClose: 10000,
            disallowClose: true,
            color: HIGHLIGHT_101_COLOR.TEXT,
            icon: _jsx(_Fragment, {}),
            styles: (theme) => ({
                root: {
                    backgroundColor: theme.fn.themeColor(HIGHLIGHT_101_COLOR.SECONDARY),
                    padding: `${theme.spacing.md}px !important`,
                },
                body: {
                    margin: "0",
                },
                description: {
                    color: theme.fn.themeColor(HIGHLIGHT_101_COLOR.TEXT),
                },
                icon: { display: "none", margin: "0" },
            }),
        });
    }, [data]);
    return _jsx(_Fragment, {});
};
